import { Component } from "react";

export const fadeUp = {
    hidden: { opacity: 0, y: 28 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
    },
};

export const staggerWrap = {
    hidden: {},
    show: { transition: { staggerChildren: 0.08 } },
};

export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-bitume text-cloud flex items-center justify-center p-8">
                    <p className="font-mono2 text-sm text-ash" data-testid="error-boundary-message">
                        Qualcosa è andato storto. Ricarica la pagina.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}
